import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const SpecialPackages = () => {
    return (
        <div className="special-packages-wrapper xmt-12 xmt-lg-20">
            <div className="container">
                <div className="title">
                    <div className="title-box title-box-purple-bold">
                        <div className="title-bg">
                            <h2 className="text">
                                بسته های ویژه
                            </h2>
                            <span className="time timer-interval-box"
                                  data-time-offer="november 25, 2021 19:37:25">00:00:00</span>
                        </div>
                        <div className="more d-none d-sm-block">
                            <span><a href="#">بیشتر</a></span>
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                    </div>
                </div>
                <div className="packages-slider">
                    <div className="swiper special-packages-swiper  position-relative">
                        <div className="swiper-scrollbar-packages position-absolute"/>
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <Link to="/singleBundlePage">
                                    <div className="packages-box position-relative xpt-20 xp-3 xpb-6">
                                        <div className="packages-price position-absolute">
                                            <span className="discount persian-number">۶،۳۰۰،۰۰۰ ت</span>
                                            <span className="total-price persian-number">۵،۷۸۵،۰۰۰ ت</span>
                                        </div>
                                        <div
                                            className="packages-products d-flex justify-content-between align-items-center xmb-6">
                                            <div>
                                                <img
                                                    src="./assets/sample-image/y6-prime-2018-listimage-blue-original.png"
                                                    alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img
                                                    src="./assets/sample-image/SAMSUNG-Silicone-Cover-Handyhülle--Samsung-Galaxy-S20--Pink.png"
                                                    alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img
                                                    src="./assets/sample-image/SANDISK-Ultra-SDHC-Speicherkarte--32-GB--80-MB-s--Class-10.png"
                                                    alt="y6"/>
                                            </div>
                                        </div>
                                        <div className="packages-text">
                                            <h3>Miband 4 + xiaomi silicon </h3>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="packages-box position-relative xpt-20 xp-3 xpb-6">
                                        <div className="packages-price position-absolute">
                                            <span className="discount persian-number">۶،۳۰۰،۰۰۰ ت</span>
                                            <span className="total-price persian-number">۵،۷۸۵،۰۰۰ ت</span>
                                        </div>
                                        <div
                                            className="packages-products d-flex justify-content-between align-items-center xmb-6">
                                            <div>
                                                <img src="./assets/sample-image/st_ecom_large_1.png" alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img src="./assets/sample-image/MWP22.png" alt="y6"/>
                                            </div>
                                        </div>
                                        <div className="packages-text">
                                            <h3>iPhone 11 + Airpods 2 </h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="packages-box position-relative xpt-20 xp-3 xpb-6">
                                        <div className="packages-price position-absolute">
                                            <span className="discount persian-number">۶،۳۰۰،۰۰۰ ت</span>
                                            <span className="total-price persian-number">۵،۷۸۵،۰۰۰ ت</span>
                                        </div>
                                        <div
                                            className="packages-products d-flex justify-content-between align-items-center xmb-6">
                                            <div>
                                                <img
                                                    src="./assets/sample-image/XIAOMI--Mi-Band-4--Fitnesstracker--155-216-mm--Schwarz (1).png"
                                                    alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img src="./assets/sample-image/HMXL-4.png" alt="y6"/>
                                            </div>
                                        </div>
                                        <div className="packages-text">
                                            <h3>Miband 4 </h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="packages-box position-relative xpt-20 xp-3 xpb-6">
                                        <div className="packages-price position-absolute">
                                            <span className="discount persina-number">۶،۳۰۰،۰۰۰ ت</span>
                                            <span className="total-price persina-number">۵،۷۸۵،۰۰۰ ت</span>
                                        </div>
                                        <div
                                            className="packages-products d-flex justify-content-between align-items-center xmb-6">
                                            <div>
                                                <img
                                                    src="./assets/sample-image/y6-prime-2018-listimage-blue-original.png"
                                                    alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img
                                                    src="./assets/sample-image/SAMSUNG-Silicone-Cover-Handyhülle--Samsung-Galaxy-S20--Pink.png"
                                                    alt="y6"/>
                                            </div>
                                            <div className="add-icon">
                                                <IconName name="add" className="icon"/>
                                            </div>
                                            <div>
                                                <img
                                                    src="./assets/sample-image/SANDISK-Ultra-SDHC-Speicherkarte--32-GB--80-MB-s--Class-10.png"
                                                    alt="y6"/>
                                            </div>
                                        </div>
                                        <div className="packages-text">
                                            <h3>Miband 4 + xiaomi silicon wrist starp green + naylon strap </h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecialPackages;
